export interface FsToggleInput {
	state: string
	roundRunning: boolean
	roundUnfinished: boolean
	inGameFreespins: boolean
	autostart: boolean
	freeSpins: number
	validBonusBet: boolean
}

/** POP FSB-UX-1: casino FS <-> real toggle only in IDLE, outside an open cycle, with spins left. */
export function canToggleFsMode(input: FsToggleInput): boolean {
	return (
		input.state === 'IDLE' &&
		!input.roundRunning &&
		!input.roundUnfinished &&
		!input.inGameFreespins &&
		!input.autostart &&
		input.freeSpins > 0 &&
		input.validBonusBet
	)
}
